import { Injectable } from "@angular/core";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import {
  map,
  catchError,
  mergeMap,
  takeUntil,
  exhaustMap,
  concatMap,
} from "rxjs/operators";
import { of } from "rxjs";
import { DocumentService } from "../services/document.service";
import { HttpEvent, HttpEventType } from "@angular/common/http";
import { serializeError } from "serialize-error";
import * as DocumentActions from "../document-states/document.actions";

@Injectable()
export class DocumentEffects {

  loadAcquisition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentActions.loadAcquisitionDocument),
      exhaustMap(({id}) =>
        this.documentService.fetchAcquisitionDocument(id).pipe(
          map((data) =>
          DocumentActions.loadAcquisitionDocumentSuccess({
              document: data,
            })
          ),
          catchError((error) =>
            of(
              DocumentActions.loadAcquisitionDocumentFailure({
                error,
              }),
            )
          ),
        )
      ),
    )
  );

  addAcquisition$ = createEffect(() =>
  this.actions$.pipe(
    ofType(DocumentActions.addAcquisitionDocument),
    concatMap(({ newDocument }) =>
      this.documentService.createAcquisitionDocument(newDocument)
        .pipe(
          map((data) => {
            // this.notification.success("Saved Successfully");
            return DocumentActions.addAcquisitionDocumentSuccess(
              {
                newDocument: data,
              },
            );
          }),
          catchError((error) =>
            of(
              DocumentActions.addAcquisitionDocumentFailure(
                { error: error.error.message },
              ),
            )
          ),
        )
    ),
  )
);

  loadClearAcquisition$ = createEffect(() =>
  this.actions$.pipe(
    ofType(DocumentActions.loadClearAcquisitionDocument),
    mergeMap((_) => of(DocumentActions.loadClearAcquisitionDocumentSuccess({
      document: [],
    }))
    )
  )
);

  uploadRequestEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentActions.documentUploadRequest),
      mergeMap(({ file, document }) =>
        this.documentService.uploadFile(file, document, "Document").pipe(
          takeUntil(
            this.actions$.pipe(ofType(DocumentActions.documentUploadCancel)),
          ),
          map((event) => this.getActionFromHttpEvent(event)),
          catchError((error) => of(this.handleError(error))),
        )
      ),
    )
  );

  private getActionFromHttpEvent(event: HttpEvent<any>) {
    // console.log("Reaching Action from HttpEvent ", event);
    switch (event.type) {
      case HttpEventType.Sent: {
        return DocumentActions.documentUploadStarted();
      }
      case HttpEventType.UploadProgress: {
        return DocumentActions.documentUploadProgress({
          progress: Math.round((100 * event.loaded) / event.total),
        });
      }
      case HttpEventType.ResponseHeader:
      case HttpEventType.Response: {
        if (event.status === 201) {
          // console.log("Reaching Action from HttpEvent ", event['body']);
          if(event['body']) {
            return DocumentActions.documentUploadSuccess(
              {
                newDocument: event['body'],
              },
            );

          }
            // this.notification.success("Saved Successfully");

          // this.documentFacade.isLoadingDocumentById();

          return DocumentActions.documentUploadCompleted();
        } else {
          return DocumentActions.documentUploadFailure({
            error: event.statusText,
          });
        }
      }
      default: {
        return DocumentActions.documentUploadFailure({
          error: `Unknown Event: ${JSON.stringify(event)}`,
        });
      }
    }
  }

  private handleError(error: any) {
    const friendlyErrorMessage = serializeError(error).message;
    return DocumentActions.documentUploadFailure({
      error: friendlyErrorMessage,
    });
  }

  constructor(
    private actions$: Actions,
    private documentService: DocumentService,
  ) {}
}
